import React from 'react';

export default function AccountPage() {
  return (
    <div>
      AccountPage
    </div>
  );
};
